import { getters } from "@shared/template/StoreTemplates/FilterStoreTemplate"

export default {
  ...getters,
  getIsEditing: state => state.isEditing,
  getLeadToEditId: state => state.leadToEditId,
  getSelectedLead: state => state.selectedLead,
  getLead: state => state.lead,
  getCurrentStep: state => state.currentStep,
  getDisabledFieldToEdit: state => state.disabledFieldToEdit,
  getPolling: state => state.polling,
  getLastImportation: state => state.lastImportation
}
